<template >
  <div  class="box text-center" 
        :class="{ 'mode-bottom': mode == 'bottom' }">
    <div  v-for="(t) in items" 
          :key="t.index" 
          class="cell"
          :class="{ 'cell-opacity': opacity }"
          :style="{ 'background-color': t.Color }">
      {{ getThresholdText(items, t) }}%
    </div>
  </div>
</template>

<script>
  import EventBus from "@/services/EventBus.js";
  import ThresholdColorMixin from '@/mixins/bmw/ThresholdColor';

  export default {
    props: {
      thresholdData: { type: Array, required: true },
      mode: { type: String, default: null },
      opacity: { type: Boolean, default: true }
    },

    mixins: [ ThresholdColorMixin ],

    data() {
      return {
        items: [],
      };
    },

    mounted() {
      // init default by using prop thresholdData (only once) 
      this.items = this.thresholdData;
      EventBus.$on("active-threshold-data", this.handleActiveThresholdChanged);
    },

    beforeDestroy() {
      EventBus.$off("active-threshold-data", this.handleActiveThresholdChanged);
    },

    methods: {
      // set new threshold. IMPORTANT: do it with a method. Comonent is used multiple times,
      // so 'EventBus.$off("active-threshold-data");' would remove ALL handlers
      handleActiveThresholdChanged(value) {
        this.items = value;
      }
    }
  }
</script>

<style scoped>

  .box {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 0.25rem;
    padding-right: 0.25rem;
    padding-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .cell-opacity {
    opacity: 0.75;
  }
  .cell {
    border-radius: 0.25rem;
    height: 24px;
    padding: 0.25rem;
  }

  .mode-bottom {
    width: 13rem;
    float: right;
    font-size: 14px;
    margin-top: auto !important;
    margin-bottom: 0rem !important;
  }

  .mode-bottom > .cell {
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
  }
</style>
